<template>
  <div>
    <b-row>
      <b-col>
        <h3 class="mr-50">
          <feather-icon size="20" icon="ListIcon" />
          سجل عمليات مسح رمز QR
        </h3>
      </b-col>
    </b-row>
    <hr />

    <b-row>
      <b-col cols="12">
        <data-table
          ref="qrScanLog"
          :ep="`v2/files-qrs/get-file-qr-logs/${id}`"
          :fields="fields"
        >
          <template #cell(created_at)="{ value }">
            {{ $moment(value).format("HH:mm DD-MM-YYYY") }}
          </template>
          <template #cell(ngoFileQR.path)="{ value }">
            <b-button
              target="_blank"
              rel="noopener noreferrer"
              :to="{ name: 'file-view', query: { ep: value } }"
              variant="flat-info"
              size="sm"
            >
              <div class="d-flex">
                <feather-icon class="mr-50" icon="EyeIcon" size="16" />
                عرض
              </div>
            </b-button>
          </template>
        </data-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BButton, BCol, BCard } from "bootstrap-vue";

import DataTable from "@/components/data-table";

export default {
  components: {
    DataTable,
    BRow,
    BButton,
    BCol,
    BCard,
  },
  props: {
    id: Number | String,
  },
  data() {
    return {
      fileDownloadModal: false,
      fields: [
        {
          key: "id",
          label: "المعرف",
        },

        {
          key: "created_at",
          label: "تاريخ المسح",
        },
        {
          key: "ngoFileQR.destination",
          label: "وجهة الملف",
        },
        {
          key: "status.name_ar",
          label: "حالة المنظمة",
        },
        {
          key: "ngoFileQR.path",
          label: " ",
        },
      ],
    };
  },
};
</script>
